import Head from 'next/head';
import type { StructuredDataSchema } from '@tac/structured-data';

type StructuredDataProps = {
  schemas?: StructuredDataSchema[];
};

export const StructuredData = ({ schemas }: StructuredDataProps) => {
  if (!schemas?.length) return null;

  return (
    <Head>
      {schemas.map(({ id, data }) => (
        <script key={id} id={id} type="application/ld+json" data-testid={id}>
          {JSON.stringify(data, null, 0)}
        </script>
      ))}
    </Head>
  );
};
